import createClientProvider from "./clientProvider";
import {reactClientWebContext} from "./useClient";

export const ReactClientProvider = createClientProvider(reactClientWebContext);
